import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useRouter } from 'vue-router'

export const useCustomizer = defineStore('customizer', () => {
    const router = useRouter()

    const isRounded = computed(() => {
        return $settings.customizer.design.corner_style == 'Rounded' ? true : false
    })

    const getFontWeight = (fontWeight) => {
        switch (fontWeight) {
            case 'Medium':
                return '500'
            case 'SemiBold':
                return '600'
            case 'Bold':
                return '700'
            default:
                return '500'
        }
    }

    const titleStyle = computed(() => {
        return `font-weight:${getFontWeight($settings.customizer.design.typography_title_font_weight)} !important; color:${$settings.customizer.design.typography_title_font_color} !important;`
    })

    const subtitleStyle = computed(() => {
        return `font-weight:${getFontWeight($settings.customizer.design.typography_subtitle_font_weight)} !important; color:${$settings.customizer.design.typography_subtitle_font_color} !important;`
    })

    const buttonStyle = computed(() => {
        return `font-weight:${getFontWeight($settings.customizer.design.button_text_font_weight)} !important; color:${$settings.customizer.design.button_text_font_color} !important; border-radius:${$settings.customizer.design.button_border_radius}px !important; border: 1px solid ${$settings.customizer.design.button_background_color} !important; background-color:${$settings.customizer.design.button_background_style == 'Filled' ? $settings.customizer.design.button_background_color : 'transparent'} !important;`
    })

    const buttonStyleSecondary = computed(() => {
        return `font-weight:${getFontWeight($settings.customizer.design.button_text_font_weight)} !important; border-radius:${$settings.customizer.design.button_border_radius}px !important;`
    })


    return { isRounded, titleStyle, subtitleStyle, buttonStyle, buttonStyleSecondary }
})
